<template>
  <MetricCard
    apiEndpoint="/instagram/impressions"
    metricName="IMPRESSIONS"
    :formatData="formatData"
    srcName="Instagram"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import MetricCard from '@/components/MetricCard.vue';
const formatData = (data) => formatNumber(data.data);
</script>
